import React from 'react';
import { Avatar, Tag } from 'antd';
import { AimOutlined, ClockCircleOutlined, EnvironmentOutlined, EyeOutlined, LikeOutlined, MessageOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import PostStatus from '@/components/poststatus';
import UserProfileLink from '@/components/userprofilelink';
import PostBadges from '@/components/postbadges';
import './index.scss';

const formatDateTime = (value, includeYear = false) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('zh-CN', {
    year: includeYear ? 'numeric' : undefined,
    month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit',
  }).format(date);
};

const PostCard = ({ post, footer, className = '' }) => {
  const author = post.user?.nickname || post.user?.username || '用户';
  const createdAt = formatDateTime(post.created_at);
  const expireAt = formatDateTime(post.expire_time, true);
  const showDistance = post.is_recruiting && ['approximate', 'exact'].includes(post.location_visibility)
    && post.distance_km != null && Number.isFinite(Number(post.distance_km)) && Number(post.distance_km) >= 0;

  return (
    <article className={`post-feed-card ${className}`} data-post-id={post.id}>
      <div className="post-feed-author">
        <UserProfileLink user={post.user}><Avatar src={post.user?.avatar || undefined} icon={<UserOutlined />} /></UserProfileLink>
        <div className="post-feed-author-info">
          <div className="postAuthorIdentity"><strong>{author}</strong><PostBadges post={post} showPinned={false} /></div>
          {createdAt && <time dateTime={post.created_at}>{createdAt} 发布</time>}
        </div>
        <PostStatus post={post} className="post-feed-status" />
      </div>
      <Link className="post-feed-card-link" to={`/posts/${post.id}`} aria-label={`查看帖子：${post.title}`}>
      <div className="post-feed-title">
        <PostBadges post={post} showSchool={false} />
        <h2>{post.title}</h2>
        {post.is_recruiting && post.post_type === 'skill_exchange' && <Tag className="post-feed-type">技能交换</Tag>}
      </div>
      <p className="post-feed-description">{post.description}</p>

      {post.cover_image && (
        <img className="post-feed-cover" src={post.cover_image} alt={`${post.title}的配图`} loading="lazy" />
      )}

      {post.tags?.length > 0 && (
        <div className="post-feed-tags">
          {post.tags.map(tag => <Tag key={tag.id}>{tag.name}</Tag>)}
        </div>
      )}

      {(post.is_recruiting || expireAt) && <div className="post-feed-meta">
        {post.is_recruiting && post.location && <span><EnvironmentOutlined />{post.location}</span>}
        {showDistance && <span><AimOutlined />距离约 {post.distance_km} 公里</span>}
        {post.is_recruiting && post.max_participants && (
          <span><TeamOutlined />招募 {post.max_participants} 人</span>
        )}
        {expireAt && <span><ClockCircleOutlined />截止 {expireAt}</span>}
      </div>}
      <div className="post-feed-engagement">
        <span><EyeOutlined /> {post.view_count ?? 0} 浏览</span>
        <span><LikeOutlined /> {post.like_count || 0} 点赞</span>
        <span><MessageOutlined /> {post.comment_count || 0} 评论</span>
      </div>
      </Link>
      {footer}
    </article>
  );
};

export default PostCard;
